import React from 'react';
import './css/Header.css';
import logo from '../assets/Color logo with background.png';

const Header = () => {
    // Handler to navigate to the AI Platform
    const goToLatestNews = () => {
        window.location.href = 'https://www.daquma.com/ai-platform';
    };

    return (
        <header className="app-header">
            <div className="header-container">
                <a href="https://www.daquma.com/" className="header-logo">
                    <img src={logo} alt="DAQUMA" />
                </a>
                <nav className="header-nav">
                    <button 
                        type="button" 
                        onClick={goToLatestNews}
                        className="header-button"
                    >
                        Latest News  
                    </button>
                </nav>
            </div>
        </header>
    );
};

export default Header;